module.exports = __webpack_public_path__ + "public/img/mendian.50949810.png";